"use client";

import Link from "next/link";
import { useTenantFeatures, isFeatureVisible } from "@/components/tenant/TenantProvider";

type Topic = { title: string; desc: string; href: string; feature?: string };

const TOPICS: Topic[] = [
  { title: "Mulai Cepat", desc: "Langkah daftar hingga mulai belajar untuk member baru.", href: "/getting-started" },
  { title: "Akun & Keamanan", desc: "Daftar, verifikasi email, lupa kata sandi, dan kelola profil.", href: "/faq" },
  { title: "Pembayaran & Pesanan", desc: "Metode bayar, status pesanan, dan ganti metode pembayaran.", href: "/faq" },
  { title: "Kelas & Sertifikat", desc: "Akses kelas, progres belajar, dan sertifikat.", href: "/my-classes" },
  { title: "Tryout & Latihan Ujian", desc: "Kerjakan tryout, lihat skor, dan pembahasannya.", href: "/tryout", feature: "tryout" },
  { title: "Membership", desc: "Paket, perpanjangan, dan benefit premium.", href: "/premium" },
  { title: "Webinar & Rekaman", desc: "Daftar webinar dan menonton rekaman.", href: "/webinars", feature: "webinar" },
  { title: "Komunitas", desc: "Diskusi & tanya jawab bersama sesama member.", href: "/community", feature: "community" },
  { title: "Program Affiliate", desc: "Ambil tautan referral dan pantau komisi.", href: "/affiliate", feature: "affiliate" },
  { title: "Dukungan", desc: "Kirim dukungan ke kreator atau hubungi admin lewat chat.", href: "/dukungan" },
];

export function HelpTopics() {
  const features = useTenantFeatures();
  return (
    <div className="mt-8 grid gap-3 sm:grid-cols-2">
      {TOPICS.filter((t) => isFeatureVisible(features, t.feature)).map((t) => (
        <Link
          key={t.title}
          href={t.href}
          className="group rounded-xl border border-black/[0.08] bg-white p-5 transition-colors hover:border-primary/40"
        >
          <h2 className="text-base font-bold text-warm-black group-hover:text-primary">{t.title}</h2>
          <p className="mt-1 text-sm leading-relaxed text-gray-600">{t.desc}</p>
        </Link>
      ))}
      <a
        href="https://growclass.id/docs/siswa/mulai/"
        target="_blank"
        rel="noopener noreferrer"
        className="group rounded-xl border border-dashed border-black/[0.15] bg-white p-5 transition-colors hover:border-primary/40 sm:col-span-2"
      >
        <h2 className="text-base font-bold text-warm-black group-hover:text-primary">Pusat Panduan Lengkap</h2>
        <p className="mt-1 text-sm leading-relaxed text-gray-600">
          Buka panduan lengkap dengan langkah lebih detail di situs bantuan Growclass.
        </p>
      </a>
    </div>
  );
}
